import { SVGProps, Ref, forwardRef } from "react";

const FolderSearchIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 16 14"
    fill="none"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Folder Search Icon"
    {...props}
  >
    <title id="Folder Search Icon">Folder Search Icon</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.667}
      d="m8.666 3.667-.743-1.488c-.214-.428-.321-.642-.481-.798a1.333 1.333 0 0 0-.498-.308C6.732 1 6.494 1 6.014 1H3.467c-.746 0-1.12 0-1.405.145a1.34 1.34 0 0 0-.583.583c-.145.285-.145.659-.145 1.405v.534m0 0h10.133c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108V9.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218H4.533c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108V3.667Zm9 7-1-1M10 8a2.333 2.333 0 1 1-4.667 0A2.333 2.333 0 0 1 10 8Z"
    />
  </svg>
);

const ForwardRef = forwardRef(FolderSearchIcon);
export default ForwardRef;
